import React from 'react';
import AveragesPreamble from './dailyAveragesBreakdownParts/averagesPreamble.js';
import AveragesChart from './dailyAveragesBreakdownParts/averagesChart.js';
import { Box } from 'bloomer/lib/elements/Box';
import { Section } from 'bloomer/lib/layout/Section';
import { Title } from 'bloomer/lib/elements/Title';

export default function DailyAveragesBreakdown({
  startDate,
  endDate,
  colors,
  averageSingleEnrichment,
  averageDailyEnrichment,
  averagesDailyForArea,
  longStay__averageSingleEnrichment,
  longStay__averageDailyEnrichment,
  longStay__averagesDailyForArea,
  behaviour__averageSingleEnrichment,
  behaviour__averageDailyEnrichment,
  behaviour__averagesDailyForArea,
  animalType,
}) {
  return (
    <Box className="on-print-own-page">
      <Title tag="h3">Daily Averages:</Title>
      <Section>
        {/* General */}
        <AveragesPreamble
          startDate={startDate}
          endDate={endDate}
          averageSingleEnrichment={averageSingleEnrichment}
          averageDailyEnrichment={averageDailyEnrichment}
          animalType={animalType}
        />
        <AveragesChart
          colors={colors}
          averageEnrichPerDay={averagesDailyForArea}
        />
      </Section>
      <Section>
        {/* Long Stay */}
        <AveragesPreamble
          startDate={startDate}
          endDate={endDate}
          averageSingleEnrichment={longStay__averageSingleEnrichment}
          averageDailyEnrichment={longStay__averageDailyEnrichment}
          longStay
          animalType={animalType}
        />
        <AveragesChart
          colors={colors}
          averageEnrichPerDay={longStay__averagesDailyForArea}
        />
      </Section>
      <Section>
        {/* Behaviour */}
        <AveragesPreamble
          startDate={startDate}
          endDate={endDate}
          averageSingleEnrichment={behaviour__averageSingleEnrichment}
          averageDailyEnrichment={behaviour__averageDailyEnrichment}
          behaviour
          animalType={animalType}
        />
        <AveragesChart
          colors={colors}
          averageEnrichPerDay={behaviour__averagesDailyForArea}
        />
      </Section>
    </Box>
  );
}
